import { JQLParser } from '@atlaskit/jql-parser';
import { operators } from './constants';
export var isPredicateOperand = function isPredicateOperand(ruleStack) {
  return ruleStack.includes(JQLParser.RULE_jqlPredicateOperand);
};
export var getPositionFromParserRule = function getPositionFromParserRule(ctx) {
  return [ctx.start.startIndex, ctx.stop ? ctx.stop.stopIndex + 1 : ctx.start.stopIndex + 1];
};
export var normalizeText = function normalizeText(text) {
  return text.toLowerCase().replace(/\s+/g, ' ').trim();
};
export var isOperator = function isOperator(maybeOperator) {
  return operators.includes(maybeOperator);
};